import React, {ReactElement} from 'react';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';

const OrderListingPlaceHolder: React.FC = (): ReactElement => {
  const mock = [1, 2, 3, 4, 5];
  return (
    <Table className="orderListingPlaceholder">
      <tbody>
        {mock.map((row: number) => {
          return (
            <TableRow key={row}>
              <TableCell />
              <TableCell>
                <Skeleton variant="rectangular" className="placeholderCell" />
              </TableCell>
              <TableCell>
                <Skeleton variant="rectangular" className="placeholderCell" />
              </TableCell>
              <TableCell>
                <Skeleton
                  variant="rectangular"
                  className="placeholderCell-item"
                />
              </TableCell>
              <TableCell>
                <Skeleton variant="rectangular" className="placeholderCell" />
              </TableCell>
              <TableCell>
                <Skeleton variant="rectangular" className="placeholderCell" />
              </TableCell>
              <TableCell>
                <Skeleton variant="rectangular" className="placeholderCell" />
              </TableCell>
            </TableRow>
          );
        })}
      </tbody>
    </Table>
  );
};

const CloseDatePlaceHolder: React.FC = (): ReactElement => {
  return (
    <div className="closeDate-status-placeHolder">
      <Skeleton variant="text" className="placeHolder-date" />
      <Skeleton variant="text" className="placeHolder-daysLeft" />
    </div>
  );
};

const TrackerPlaceHolder: React.FC = (): ReactElement => {
  return (
    <div className="tracker-status">
      <div className="tracker-status-placeHolder">
        <Skeleton variant="text" className="placeHolder-order" />
        <Skeleton animation="wave" className="placeHolder-progressBar" />
        <Skeleton variant="text" className="placeHolder-amount" />
      </div>
    </div>
  );
};

const ProductCardPlaceHolder: React.FC = (): ReactElement => {
  function buildThumbnails(num: number) {
    const numOfThumnails = num;
    return Array.from(Array(numOfThumnails).keys()).map(item => {
      return <Skeleton className="thumbnail-skeleton" key={item} />;
    });
  }

  const carousel = buildThumbnails(6);
  const sizes = buildThumbnails(3);

  return (
    <div className="productCard-placeHolder">
      <Box className="placeHolder-carousel">
        <Skeleton className="placeholder-slider" variant="rectangular" />

        <div className="placeholder-thumbnail-container">{carousel}</div>
      </Box>
      <Box className="placeHolder-detail">
        <div className="detail-description">
          <Skeleton variant="text" className="productName" />
          <Skeleton variant="text" className="proudctPrice" />
          <div className="productColor">
            <Skeleton variant="text" className="colorName" />
          </div>
          <Skeleton variant="text" className="size" />
        </div>
        <div className="size-container">{sizes}</div>
        <Skeleton variant="text" className="sizing" />
      </Box>
    </div>
  );
};

export {
  OrderListingPlaceHolder,
  CloseDatePlaceHolder,
  TrackerPlaceHolder,
  ProductCardPlaceHolder
};
